(() => {
  const EVENT_NAME = "alia_email_signup";
  const STORAGE_PREFIX = "darkstims:alia-email-lead";
  const MAX_PUBLISH_ATTEMPTS = 10;
  const RETRY_DELAY_MS = 200;

  function createEventId() {
    if (globalThis.crypto?.randomUUID) {
      return globalThis.crypto.randomUUID();
    }

    return `alia-${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }

  function publishSignup(customData, storageKey, attempt = 0) {
    const publish = globalThis.Shopify?.analytics?.publish;

    if (typeof publish !== "function") {
      if (attempt < MAX_PUBLISH_ATTEMPTS) {
        globalThis.setTimeout(
          () => publishSignup(customData, storageKey, attempt + 1),
          RETRY_DELAY_MS,
        );
      }
      return;
    }

    globalThis.Shopify.analytics.publish(EVENT_NAME, customData);

    try {
      globalThis.sessionStorage.setItem(storageKey, "1");
    } catch {
      // Tracking still works when session storage is unavailable.
    }
  }

  document.addEventListener("alia:signup", (event) => {
    const detail = event.detail ?? {};

    if (!detail.email) return;

    const campaignId = String(detail.campaignID ?? "");
    const popupId = String(detail.popupID ?? "");
    const storageKey = `${STORAGE_PREFIX}:${campaignId}:${popupId}`;

    try {
      if (globalThis.sessionStorage.getItem(storageKey)) return;
    } catch {
      // Continue without session-level deduplication when storage is unavailable.
    }

    publishSignup(
      {
        event_id: createEventId(),
        campaign_id: campaignId,
        popup_id: popupId,
        source: "alia",
      },
      storageKey,
    );
  });
})();
